<template>
  <div>
    <div style="display: flex;margin-bottom:20px;margin-left:40px;">
      <el-page-header @back="back" style="margin-right:20px;"></el-page-header>
    </div>
    <div class="frameBox">
      <iframe :src="path" frameborder="0" style="width: 100%; height:100%"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      path: ''
    }
  },
  created () {
    // 生命周期里接收参数
    this.path = this.$route.query.path // 接受参数关键代码
    console.log(this.path)
  },
  mounted () {},
  methods: {
    // 点击返回上一步
    back () {
      this.$router.go(-1) // 返回上一层
    }
  }
}
</script>
<style scoped lang='less'>
button {
  width: 100px !important;
}
.frameBox{
  height:  calc(100vh - 110px);
}
</style>
